import type { AbschlussForm, CheckupLogData } from "@/checkup/types/types";
import { useGet, usePost } from "@/api/lib/integration";
import type { CheckupStateResponse, CheckupStepDataPostRequest, CheckupStepDataPostResponse } from "@/api/checkup/types";


export const logCheckup = usePost<CheckupLogData, void>('/api/checkup/log');
export const abschluss = usePost<AbschlussForm, void>('/api/checkup/abschluss');
export const getSessionData = useGet<void, CheckupStateResponse>('/api/checkup')
export const postSessionData = usePost<CheckupStepDataPostRequest, CheckupStepDataPostResponse>('/api/checkup')
